/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AccountSelect from './AccountSelect/index'
import AmountInput from './AmountInput/index'
import CancelAction from './CancelAction/index'
import CloseAction from './CloseAction/index'
import ContactMethodSelect from './ContactMethodSelect/index'
import Loading from './Loading/index'
import MessageInput from './MessageInput/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import SubmitAction from './SubmitAction/index'
import TreatmentSelect from './TreatmentSelect/index'
import TysiaIconPaymentPlan from 'DesignSystem/Svgs/TysiaIconPaymentPlan/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsRequestPayment/Content",
  isSubmitting
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsBlue800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.800'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let paymentsRequestPaymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_request_payment',
})
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 width={720}
 height={534}
 paddingTop={0}
 paddingRight={0}
 paddingBottom={0}
 paddingLeft={0}
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--pt-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-5-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--btlr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbc-8-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconPaymentPlan
  viewPath={`${viewPath}/TysiaIconPaymentPlan`}
 height={18}
 width={18}
 fill={dtColorsBlue800}
 marginRight={dtSpaceXxs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 weight="medium"
 color={dtColorsNeutral900}
 text="Pay request"
/>
</div>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsNeutral100,'--oy-9-Z1Yf8zk': paymentsRequestPaymentIsSubmittingData ? "hidden" : "auto"}}
 className={`views-block ${styles.Vertical}`}
>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-5-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical1}`}
>
<AccountSelect
  viewPath={`${viewPath}/AccountSelect`}
/>
<TreatmentSelect
  viewPath={`${viewPath}/TreatmentSelect`}
/>
<AmountInput
  viewPath={`${viewPath}/AmountInput`}
/>
<MessageInput
  viewPath={`${viewPath}/MessageInput`}
/>
<ContactMethodSelect
  viewPath={`${viewPath}/ContactMethodSelect`}
/>
</div>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--pt-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-5-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bc-1-Z1Yf8zk': dtColorsWhite,'--btc-10-Z1Yf8zk': dtColorsNeutral200,'--bblr-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-12-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<SubmitAction
  viewPath={`${viewPath}/SubmitAction`}
/>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}